/**
 * SGKE061A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface RepayStateDiv {

    /**
     * コード値
     */
    codeValue?: string;
    /**
     * 名称
     */
    aname?: string;
}

